// extracted by mini-css-extract-plugin
export default {"container":"xe_sAj","title":"viblCT","textButton":"we0qzZ"};